module.exports = __webpack_public_path__ + "static/media/homebanner-bg.be59273d.png";